import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { Toaster } from "sonner";
import { router } from "@/app/router";
import { ConfirmProvider } from "@/components/ui/confirm";
import { UploadProvider } from "@/features/upload/provider";
import { ApiError } from "@/lib/api/client";
import { AuthProvider } from "@/lib/auth/session";
import { useTheme } from "@/lib/theme";
import "@/styles/index.css";

/** Toaster 跟随明暗主题实时切换。 */
function AppToaster() {
  const theme = useTheme();
  return <Toaster theme={theme} position="top-center" richColors toastOptions={{ style: { fontFamily: "var(--font-sans)" } }} />;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
    mutations: { retry: false },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ConfirmProvider>
          <UploadProvider>
            <RouterProvider router={router} />
          </UploadProvider>
          <AppToaster />
        </ConfirmProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
